import React from 'react';
import PropTypes from 'prop-types';
// components
import Button from '../Button';
// assets
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import Tooltip from '@mui/material/Tooltip';
import { CircularProgress, Typography } from '@mui/material';
// services
import api from '../../services/api';
import { downloadBlobAsFile } from './lib';
// constants
import { FILE_EXTENSIONS_TYPE, OPEN_XML_SPREADSHEET_MIME_TYPE } from './constants';
import { DOWNLOAD_URL } from '../../constants/api';
import { getAppliedFiltersPayload } from '../../constants/utils';

const ReportDownloadComponent = ({
  component,
  appliedFilters,
  filename,
  setIsDownloading,
  isDownloading,
  fileType = OPEN_XML_SPREADSHEET_MIME_TYPE,
  downloadButtonText = '',
  disabled = false,
  customButtonStyle = {},
  multiComponentPayload = false,
}) => {
  const handleDownload = async () => {
    setIsDownloading(true);
    try {
      const filters = multiComponentPayload
        ? appliedFilters
        : getAppliedFiltersPayload(component, appliedFilters);
      const response = await api.post(DOWNLOAD_URL, filters, {
        responseType: 'blob',
      });

      if (!fileType) {
        const splits = filename?.split('.');
        fileType = FILE_EXTENSIONS_TYPE[splits[splits.length - 1]];
      }

      if (!fileType) {
        throw new Error(
          'Could not determine file type. Provide a valid file extension or type mapping in constants.'
        );
      }

      downloadBlobAsFile(response?.data, filename, fileType);
    } catch (error) {
      console.error('Error downloading file:', error);
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <Tooltip title="Download File" placement="bottom">
      <span>
        <Button
          onClick={handleDownload}
          style={{
            display: 'flex',
            gap: '15px',
            backgroundColor: '#e4e4e7',
            marginTop: '12px',
            height: '40px',
            ...customButtonStyle,
          }}
          disabled={isDownloading || disabled}
        >
          {isDownloading ? (
            <CircularProgress size="2rem" sx={{ color: '#000' }} />
          ) : (
            <CloudDownloadIcon />
          )}
          {!!downloadButtonText && (
            <Typography variant="subtitle1" fontWeight="450">
              {downloadButtonText}
            </Typography>
          )}
        </Button>
      </span>
    </Tooltip>
  );
};

ReportDownloadComponent.propTypes = {
  component: PropTypes.string,
  appliedFilters: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  filename: PropTypes.string.isRequired,
  setIsDownloading: PropTypes.func,
  isDownloading: PropTypes.bool,
  fileType: PropTypes.string,
  downloadButtonText: PropTypes.string,
  disabled: PropTypes.bool,
  customButtonStyle: PropTypes.object,
  multiComponentPayload: PropTypes.bool,
};

export default ReportDownloadComponent;
